<template>
<div class="panal mt-20">
<div class="panal-header">History </div>

<div class="table-responsive p-3">
<table class="table table-hover table-bordered">
  <thead class="thead-light">
    <tr>
      <th scope="col" >Faculty Name</th>
      <th scope="col" >Semester</th>
      <th scope="col" >Action Name</th>
      <th scope="col" >Action Deadline</th>
      <th scope="col" >Action Time</th>
      <th scope="col" >Location</th>
      <th scope="col" >View History</th>
    </tr>
  </thead>
  <tbody>
                  <tr v-if="empty"><td colspan="7"> No Data </td></tr>

    <tr v-else v-for="item in ApplicantActionsHistoryList" v-bind:Key="item.ApplicationHistoryID">
     <td> {{item.FacultyNameEN}}</td>
     <td>{{item.SemesterName}}</td>
     <td>{{item.ProcessNameEN}}</td>
     <td>{{item.StatusDate | moment("llll")}}</td>
     <td>{{item.ApplicantDate | moment("llll")}}</td>
     <td>{{item.BrancheNameEN}}</td>
     <td> <b-button v-b-modal.history v-b-tooltip.hover title="View History" v-on:click="History(item.ApplicationID)" ><b-icon-clock-history  /></b-button>
</td>

    
    
    
    </tr>


  </tbody>
</table>

   <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

</div>

  <b-modal id="history"   centered hide-footer  size="lg" title="History">
   
  <div class="panal">
    <div>
      
      <div class="panal-header"> Application History </div>
          <div class="panal-body">
<table class="table table-hover table-bordered">
  <thead class="thead-light">
    <tr>
      <th scope="col" >Faculty Name</th>
      <th scope="col" >Semester</th>
      <th scope="col" >Action Name</th>
      <th scope="col" >Action Deadline</th>
      <th scope="col" >Action Time</th>
      <th scope="col" >Location</th>
      <th scope="col" >Status</th>
     
    </tr>
  </thead>
  <tbody>
              <tr v-if="empty"><td colspan="7"> No Data </td></tr>

    <tr v-else v-for="item in historyList" v-bind:Key="item.ApplicationHistoryID">
      <td> {{item.FacultyNameEN}}</td>
     <td>{{item.SemesterName}}</td>
     <td>{{item.ProcessNameEN}}</td>
     <td>{{item.StatusDate | moment("llll")}}</td>
     <td>{{item.ApplicantDate | moment("llll")}}</td>
     <td>{{item.BrancheNameEN}}</td>
     <td v-bind:class="[item.StatusNameEN == 'In Progress' ? 'label text-warning' : ' label text-success']">{{item.StatusNameEN}}</td>
    
    
    </tr>

    
  </tbody>
</table>
      </div>
     </div>

  </div>


  </b-modal>

</div>


</template>

<script>
//import { ApplicantActionsHistoryList } from '../models/Applicant'
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'
export default {
        name: 'History',
        data(){
          return{
            ApplicantActionsHistoryList:[] ,//new ApplicantActionsHistoryList('','','','','','','','','','','','','',''),
            submitted:false,
            loading: false,
            successful: false,
            message:'',
            empty:false,
            historyList:[]
          }
        },
        mounted(){

         ApplicantDataServices.GetListOfCurrentAndHistoryActions(this.currenUser.UserIDSerial).then(Response => {
        /*eslint-disable-next-line*/
              this.ApplicantActionsHistoryList = Response.data.ApplicationUpComing
        
      }, error => {
        
                   this.empty = true
                 
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
          if(error.response.status == 404) this.message =''
      }).catch(error => {
       
        this.message = error + 'no data '
      })
        },
        computed:{
          currenUser() {
        return this.$store.state.auth.user
      }
        },
        methods:{

          History(ApplicationID){
            ApplicantDataServices.GetApplicantApplicationHistory(ApplicationID).then(Response=>{
              this.historyList = Response.data
            })
          }
          
        }

    }
</script>

<style scoped>

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}

th{
font-weight:bold;
}
.su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
}

.table .thead-light th {
 font-size: 14px;
 width: 15%;
}

</style>